
import {$, bool, cpfOrCnpj, datetime, ID, InputType, Schema} from 'simpli-web-sdk'
import DeliveryReceiverResponse from '@/model/response/DeliveryReceiverResponse'
import RenderNumber from '@/components/render/RenderNumber.vue'

export default (model: DeliveryReceiverResponse): Schema => ({

    nome: {
        content: model.nome,
    },

    documento: {
        content: cpfOrCnpj(model.documento),
    },

    qtdTotal: {
        content: {
            component: RenderNumber,
            props: {
              number: model.qtdTotal,
            },
        },
        textContent: model.qtdTotal || '0',
    },

    qtdSemOcorrencia: {
        content: {
            component: RenderNumber,
            props: {
                number: model.qtdSemOcorrencia,
            },
        },
        textContent: model.qtdSemOcorrencia || '0',
    },

    qtdComOcorrencia: {
        content: {
            component: RenderNumber,
            props: {
                number: model.qtdComOcorrencia,
            },
        },
        textContent: model.qtdComOcorrencia || '0',
    },

    qtdDevolvidas: {
        content: {
            component: RenderNumber,
            props: {
                number: model.qtdDevolvidas,
            },
        },
        textContent: model.qtdDevolvidas || '0',
    },

})
